import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Attendance {
  constructor() {
    this.auth = new Auth()
  }

  staff = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}attendance/staff`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
  status = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}attendance/status`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  action = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}attendance/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
